<template>
  <div id='index' v-if="body_show">
    <!-- 迷你播放器 -->
    <div class="user_share money_box" v-if="status==1 || (status==0 && pblname)">
      <div class="scoure_name">
        {{pblname}}
      </div>
      <div class="play_mini">
        <public-audio2 :mini="true" :volume="0.8" :src="music"></public-audio2>
      </div>
    </div>
     <!-- 自我探索详情页 -->
    <div class="discovery-box">
        <img  width="100%"  src="@a/self_discovery/zuijia_01.png" >

      <!-- 价格和时间 -->
      <div :class="['money_box',status==1 || (status==0 && pblname)?'money_boxss':'']">
        <div class="money_">
          <div class="money_left">优惠价：<span>¥{{data.courseprice}}</span></div>
          <div class="money_right">原价999，限时优惠200</div>
        </div>
        <div class="date_">{{data.begintime}} 开课</div>
      </div>
      <!-- 自我探索图片 -->
      <img  width="100%"  src="@a/self_discovery/zuijia_03.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_04.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_05.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_06.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_07.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_08.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_09.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_10.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_11.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_12.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_13.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_14.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_15.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_16.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_17.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_18.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_19.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_20.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_21.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_22.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_23.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_24.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_25.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_26.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_27.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_28.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_29.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_30.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_31.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_32.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_33.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_34.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_35.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_36.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_37.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_38.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_39.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_40.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_41.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_42.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_43.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_44.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_45.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_46.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_47.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_48.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_49.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_50.png" >
      <img  width="100%"  src="@a/self_discovery/zuijia_51.png" >
    </div>
    <!-- 自我探索详情页  end -->
    <!-- 按钮 -->
    <div class="into_btn_box">
      <div class="into_btn" v-if="!data.ishavedbuy">
        <a class="free_learn" @click="free_learn" href="javascript:;">免费试学</a>
        <a class="sign_immediately" @click="signHandle" v-if="data.surplus>0">
                    立即报名<br />
                </a>
        <a class="sign_immediately" v-else>预约报名</a>
      </div>
      <router-link class="into_project" :to="url_substying(data.ishavedbuy) + '?cid=' + cid" v-else>进入【项目】</router-link>
    </div>
    <!-- 验证手机号和付款 -->
    <public-mobile ref="handle" :cid="cid" :source="source" :type="'course'" :pdk="pdk" :aspx="aspx" @statistic_="statistic_"></public-mobile>
    <!-- 默认弹出层 -->
    <van-popup :close-on-click-overlay="false" v-model="nextModule" class="pop_assistant">
      <div class="pop_assistant_box">
        <h2>有您这样的朋友真是一大幸事！希望这节课能给您这位幸运的朋友带来帮助。</h2>
        <h5>小提示：一次只能送给一位朋友哦。</h5>
        <h1>价格：{{price}}元</h1>
        <div class="next-btn" @click="give_pay">确定送课</div>
        <router-link class="return-course" :to="{
            path:'/course_content',
            query:{cid:this.$route.query.cid,id:this.$route.query.subject_id,cpid:this.$route.query.cpid
            }
          }">
          返回课程
        </router-link>
      </div>
    </van-popup>
    <img class="give_share" alt="分享图片" src="@a/give_share.png" v-show="give_share">
  </div>
</template>
<script>
import {
  statistics
} from "@/api/public";
import {
  coursedetail,
  project_click_time,
  statistic_next,
  check_gift
} from "@/api/course"
import {
  shareCon
} from "@/utils/wxconfig";
import {
  get_gift
} from "@/api/pay";

export default {
  data() {
      return {
        pblname: "",
        name: "",
        music: "",
        body_show: false,
        cid: null,
        data: {},
        phone: null,
        source: '',
        pdk: '',
        aspx: '',
        nextModule: false,
        sharecode: "",
        give_share: false,
        params: {},
        price: "",
        status: null,
        type_obj: {type_title:""}
      }
    },
    methods: {
      pullData() {
        this.sharecode = this.$route.query.sharecode + '';
        coursedetail({
            bid: this.$route.query.bid
          })
          .then((data) => {
            this.body_show = true;
            this.data = data;
            this.cid = String(data.id);
            this.source = this.$route.query.source || '';
            // 分享
            this.pdk = this.$route.query.pdk || '';
            this.aspx = this.$route.query.aspx || '';

            if (this.sharecode == 'false') {
              this.give_subject();
            } else {
              this.give_check();
            }
          })
        shareCon("course2",this, this.type_obj);
      },
      // 立即报名
      signHandle() {
        this.statistical("coursebtn");
        if (this.data.mobilestatus) {
          // 是否需要验证验证码
          this.$refs.handle.need_verify = this.data.need_verify || false;
          // 判断用户手机号是否已验证
          this.$refs.handle.phone = this.data.userdetail.mobile ? this.data.userdetail.mobile : null;
          this.$refs.handle.show = true;

        } else {
          this.$refs.handle.pay()
        }
      },
      // 检验分享码
      give_check() {
        check_gift({
            sharecode: this.sharecode
          })
          .then((data) => {
            this.status = data.status;
            this.pblname = data.name;
            this.music = data.audio;
            if (data.status == 0) {
              this.give_share = true;
              this.type_obj.type_title = data.title;
              shareCon("course",this, this.type_obj);
            }
          });
      },
      // 判断分享传过来的数据
      give_subject() {
        return get_gift({
            subject_id: this.$route.query.subject_id
          })
          .then((data) => {
            this.params = data.params;
            this.price = data.price;
            if(!this.price) {
              this.nextModule = false;
            } else {
              this.nextModule = true;
            }
            this.sharecode = data.sharecode;
          });
      },
      // 支付
      give_pay() {
        this.$toast({
          type: 'loading',
          mask: true,
          message: '加载中...'
        });
        let jsApiCall = () => {
          WeixinJSBridge.invoke(
            'getBrandWCPayRequest', this.params, (rest) => {
              this.$toast.clear();
              WeixinJSBridge.log(rest.err_msg);
              if (rest.err_msg == "get_brand_wcpay_request:ok") {
                this.give_subject().then(()=>{
                  if(this.sharecode) {
                    location.href = `discovery_give_share?bid=${this.$route.query.bid}&subject_id=${this.$route.query.subject_id}&sharecode=${this.sharecode}`;
                  }
                });
                // let query = this.$router.history.current.query;
                // let path = this.$router.history.current.path;
                // //对象的拷贝
                // let newQuery = JSON.parse(JSON.stringify(query));
                // newQuery.sharecode = this.sharecode;
                // this.$router.push({
                //   path,
                //   query: newQuery
                // });
              } else if (rest.err_msg == "get_brand_wcpay_request:cancel") {
                alert("支付取消！")
              } else {
                alert("支付失败！")
              }
            }
          );
        };
        if (typeof WeixinJSBridge == "undefined") {
          if (document.addEventListener) {
            document.addEventListener('WeixinJSBridgeReady', jsApiCall, false);
          } else if (document.attachEvent) {
            document.attachEvent('WeixinJSBridgeReady', jsApiCall);
            document.attachEvent('onWeixinJSBridgeReady', jsApiCall);
          }
        } else {
          jsApiCall();
        }
      },
      // 本地统计
      statistical(data) {
        statistics({
          type: data
        }).then();
      },
      statistic_() {
        statistic_next({
            cid: this.data.id
          })
          .then();
      },
      // 免费试学
      free_learn() {
        project_click_time({
            cid: this.data.id
          })
          .then((data) => {
            // 免费试学跳转
            this.$router.push("/list?cid=" + this.cid);
          });
      },
      // 截取返回link中的地址中的路由名称
      url_substying(url_) {
        let index = url_.lastIndexOf('/');
        let last = url_.lastIndexOf('.');
        let x = url_.substring(index, last);
        return x
      },
    },
    created() {
      this.pullData();
    }

}
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
#index {
  background: url(../../../assets/self_discovery/zuijia_02.png) no-repeat;
  z-index: 1;
  position: relative;
  padding-bottom: 98px;
  background-size: 100% 100%;
}

// 课程的价格和开课时间
.money_box {
  border-radius: changeRem(.32)+px;
  margin: 0 16px 20px;
  box-shadow: 0px 0px 14px 0px rgba(235, 80, 50, 0.1);
  background-color: #FFF;
  position: relative;
  padding: 0 changeRem(.6)+px changeRem(.8)+px;
  z-index: 1;
  .money_ {
    display: flex;
    padding-top: changeRem(1)+px;
    .money_left {
      margin-right: auto;
      font-size: changeRem(.52)+px;
      span {
        font-size: .88rem;
        color: #EA345C;
      }
    }
    .money_right {
      margin-left: auto;
      font-size: changeRem(.48)+px;
      background-color: #EA345C;
      color: #FFF;
      position: relative;
      // height: changeRem(.6)+px;
      line-height: changeRem(.6)+px;
      align-self: center;
      padding: changeRem(.16)+px changeRem(.24)+px changeRem(.16)+px changeRem(.6)+px;
    }
    .money_right:after {
      position: absolute;
      content: "";
      width: 0;
      height: 0;
      left: changeRem(-.2)+px;
      top: changeRem(.25)+px;
      border-right: changeRem(.2)+px solid #EA345C;
      border-top: changeRem(.2)+px solid #FFF;
      border-bottom: changeRem(.2)+px solid #FFF;
    }
  }
  .date_ {
    background-image: url(../../../assets/cur1.png);
    width: changeRem(6.6)+px;
    line-height: changeRem(1.4)+px;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    color: #EA345C;
    font-size: changeRem(.52)+px;
    margin-top: changeRem(.6)+px;
    text-align: center;
  }
}

.money_boxss {
  margin-top: 40px
}

.user_share {
  padding: 0;
  padding-right: changeRem(1)+px;
  padding-top: changeRem(0.8)+px;
  .scoure_name {
    padding-left: changeRem(0.7)+px;
  }
}

// 按钮
.into_btn_box {
  background: #fff;
  width: 100%;
  max-width: 750px;
  line-height: changeRem(1.96)+px;
  height: auto;
  position: fixed;
  left: 50%;
  margin-left: -375px;
  bottom: 0;
  text-align: center;
  z-index: 2;
  font-size: changeRem(.68)+px;
  .into_project {
    display: block;
    width: 100%;
    line-height: changeRem(1.96)+px;
    text-align: center;
    background: #EA345C;
    text-align: center;
    color: #fff;
  }
  .into_btn {
    display: flex;
  }
  .free_learn {
    color: #EA345C;
    display: block;
    width: 214px;
    text-align: center;
  }
  .sign_immediately {
    flex: 1;
    background-color: #EA345C;
    color: #fff;
  }
}

// 修改之
.scoure_name {
  font-size: 30px;
  color: #333333;
}


/*弹窗带二维码的*/

.pop_assistant {
  text-align: center;
  background-color: transparent;
  .pop_assistant_box {
    width: 600px;
    border-radius: 8px;
    background-color: #fff;
    padding: 10px 85px 26px;
    img {
      width: 434px;
      height: 434px;
    }
    h3 {
      margin-top: 44px;
      font-size: 34px;
      color: #333333;
      line-height: 50px;
      span.on {
        color: #EA345C;
      }
    }
    h1 {
      margin: 0 auto;
      line-height: 52px;
      font-size: 36px;
      color: #EA345C;
      margin-top: 60px
    }
    h2 {
      width: 460px;
      margin: 0 auto;
      margin-top: 120px;
      line-height: 52px;
      font-size: 36px;
      text-align: center;
      color: #333
    }
    h5 {
      width: 460px;
      margin: 0 auto;
      line-height: 52px;
      font-size: 26px;
      color: #666;
      margin-top: 60px
    }
    h4 {
      margin-top: 10px;
      font-size: 24px;
      color: #666;
      line-height: 30px;
    }
    .next-btn {
      display: block;
      margin: 0 auto;
      margin-top: 60px;
      margin-bottom: 80px;
      width: changeRem(7.7)+px;
      height: changeRem(1.6)+px;
      line-height: changeRem(1.6)+px;
      background: #EA345C;
      border-radius: changeRem(0.16)+px;
      color: #fff;
      font-size: changeRem(0.68)+px;
      text-align: center;
    }
  }
}

img.give_share {
  width: 100%;
  position: fixed;
  top: 0;
  left: 50%;
  z-index: 1000;
  height: 100%;
  max-width: 750px;
  margin-left: -375px;
}
.return-course{
  display: inline-block;
  font-size: 26px;
  color: #333;
  border-bottom: 1px solid #333;
  padding-bottom: 2px;
  margin-bottom: 20px;
}
</style>
